<template>
	<b-nav v-if="showNav">
		<b-nav-item-dropdown id="my-nav-dropdown " text="eSim" toggle-class="nav-link-custom">
			<template slot="button-content">
				<i class="fa mr-2 fa-sim-card text-green" font-scale="1"></i>
				<span>eSim</span>
			</template>
			<b-dropdown-item v-if="navPermissions['inventory'].enable" to="/esim/inventory">
				<i class="fa fa-folder-open text-green" font-scale="1"></i>
				Inventory
			</b-dropdown-item>
			<b-dropdown-item v-if="navPermissions['profile'].enable" to="/esim/profile/:iccid=e">
				<i class="fa fa-info text-yellow" font-scale="1"></i>
				Profile
			</b-dropdown-item>
			<!-- <b-dropdown-item v-if="navPermissions['order'].enable" to="/esim/order">
				<i class="fa fa-cart-arrow-down text-teal" font-scale="1"></i>
				Order
			</b-dropdown-item> -->
			<b-dropdown-item v-if="navPermissions['report'].enable" to="/esim/report">
				<i class="fa mr-2 fa-file-invoice text-danger" font-scale="1"></i>
				Report
			</b-dropdown-item>
			<b-dropdown-item v-if="navPermissions['qrcode'].enable" to="/esim/qrcode/:iccid=">
				<i class="fa fa-qrcode text-orange" font-scale="1"></i>
				QrCode
			</b-dropdown-item>
			<b-dropdown-item v-if="isPortalAdminStatus" to="/esim/import">
				<i class="fa fa-upload text-red" font-scale="1"></i>
				Import &nbsp; <i class="fa fa-lock text-gray size-32"></i>
			</b-dropdown-item>
			<b-dropdown-item v-if="isPortalAdminStatus" to="/esim/carrier_admin">
				<i class="fa fa-wrench text-indigo" font-scale="1"></i>
				Carrier &nbsp; <i class="fa fa-lock text-gray size-32"></i>
			</b-dropdown-item>
		</b-nav-item-dropdown>
	</b-nav>
</template>
<script>
import initService from "../../../common/api-services/init-service";

export default {
	name: "top-e-sim-group",
	data() {
		return {
			isPortalAdminStatus: false,
			isAdminStatus: false,
			groups: [],

			showNav: false,

			navPermissions: {
				inventory: {
					enable: false,
					role: ["ESIM_ADMIN", "ESIM_EDIT", "ESIM_READ", "Administrator"],
				},
				profile: {
					enable: false,
					role: ["ESIM_ADMIN", "ESIM_EDIT", "ESIM_READ", "Administrator"],
				},
				// order: {
				// 	enable: false,
				// 	role: ["ESIM_ADMIN", "ESIM_EDIT", "Administrator"],
				// },
				report: {
					enable: false,
					role: ["ESIM_ADMIN", "Administrator"],
				},
				qrcode: {
					enable: false,
					role: ["ESIM_ADMIN", "ESIM_EDIT", "ESIM_READ", "Administrator"],
				},
				import: {
					enable: false,
					role: ["PORTAL_ADMIN"],
				},
				carrier: {
					enable: false,
					role: ["PORTAL_ADMIN"],
				},
				help: {
					enable: false,
					role: ["ESIM_ADMIN", "ESIM_EDIT", "ESIM_READ", "Administrator"],
				},
			},
		};
	},
	mounted() {
		this.isPortalAdminStatus = initService.getPortalAdminRole();
		this.isAdminStatus = initService.getAdministratorRole() || initService.getPortalAdminRole();
		this.groups = initService.getGroups();
		//console.log("groups:", this.groups);
		Object.keys(this.navPermissions).map(item => {
			this.groups.map(it => {
				if (this.navPermissions[item].role.includes(it)) {
					this.navPermissions[item].enable = true;
					this.showNav = true;
				}
			});
		});
	},
};
</script>
